export const TERMS_LINK = 'https://hotjar.com/terms';
